/**
 * @owner @Appboy/messaging-experience
 */
import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";

import { isMessagePrioritizationEligibleChannel } from "./isMessagePrioritizationEligibleChannel";

export interface PartitionedChannelsByEligibility {
  eligible: SelectableMessageType[];
  ineligible: SelectableMessageType[];
}

/**
 * Splits available channels into Message Prioritization eligible and ineligible groups.
 * Preserves the input order in each group.
 *
 * @param channels - Channels offered in the empty-state picker, in display order.
 * @returns Eligible and ineligible lists in the same relative order as `channels`.
 */
export const partitionChannelsByEligibility = (
  channels: readonly SelectableMessageType[]
): PartitionedChannelsByEligibility => {
  const eligible: SelectableMessageType[] = [];
  const ineligible: SelectableMessageType[] = [];

  channels.forEach((channel) => {
    if (isMessagePrioritizationEligibleChannel(channel)) {
      eligible.push(channel);
    } else {
      ineligible.push(channel);
    }
  });

  return { eligible, ineligible };
};
